module.exports = __webpack_public_path__ + "img/zuo.prt.164ea742.jpg";